const formatMoneyNumber = (number, precision = 2) => {
  let _number = parseFloat(number);
  _number = _number.toLocaleString('en-US', {
    maximumFractionDigits: precision,
  });
  return _number;
};

export const formatNumber = (number, precision = 2) => {
  let _number = parseFloat(number).toLocaleString('en-US', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
    useGrouping: false,
  });
  return _number;
};

export default formatMoneyNumber;
